import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Identity } from './components/Identity';
import { Philosophy } from './components/Philosophy';
import { Activities } from './components/Activities';
import { Jurisdiction } from './components/Jurisdiction';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy text-cream selection:bg-gold selection:text-navy" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Identity data-id="element-4" />
        <Philosophy data-id="element-5" />
        <Activities data-id="element-6" />
        <Jurisdiction data-id="element-7" />
        <Contact data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}